<template>
    <div class="container-fluid why-join-the-club">

        <h2 class="title">Why Join The Club</h2>

        <div class="row sections">
            <div class="col-lg-4 section-block">
                <div class="block-item community-of-travel-lovers">
                    <div class="media">
                        <img alt="A Community of Travel Lovers" src="/images/gate/trio_asset_1_lwsazy.png" loading="lazy">
                    </div>
                    <div class="info">
                        <h3><span>1.</span>A Community of Travel Lovers</h3>
                        <p>Get the inside scoop from a like-minded community of members who love to travel just as much as you do.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 section-block">
                <div class="block-item relatable-recommendations">
                    <div class="media">
                        <img alt="Relatable Recommendations" src="/images/gate/trio_asset_2_as9drk.png" loading="lazy">
                    </div>
                    <div class="info">
                        <h3><span>2.</span>Relatable Recommendations</h3>
                        <p>Never waste time planning a trip again. Easily find recommendations curated to fit your travel style with real reviews, from travelers like you.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 section-block">
                <div class="block-item perfeect-hotel-stay">
                    <div class="media">
                        <img alt="Your Perfect Hotel Stay" src="/images/gate/trio_asset_3_xy5fmv.png" loading="lazy">
                    </div>
                    <div class="info">
                        <h3><span>3.</span>Your Perfect Hotel Stay</h3>
                        <p>Pack your bags and we'll handle the rest. We've partnered with 1000s of hotels to bring you the best pricing, top notch service and members-only perks on every booking.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="join-the-club-button">
            <JoinTheClubCtaButton />
        </div>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers'
import JoinTheClubCtaButton from '@/components/JoinTheClubCtaButton'

export default {
    mixins: [Helpers],

    components:{
        JoinTheClubCtaButton
    }
}
</script>
